import templateUrl from './project-user-card.html'
import './project-user-card.scss'

const ProjectUserCardComponent = {
  bindings: {
    // user: '<',
    customTitle: '@title',
    project: '<'
  },
  templateUrl,
  controller: class ProjectUserCard {
    constructor (UserService, PusherService, ModalService, $filter) {
      'ngInject'
      this._identify = 'ProjectUserCardComponent'
      this.UserService = UserService
      this.PusherService = PusherService
      this.ModalService = ModalService
      this.$filter = $filter
    }

    get user () {
      // project is nulled by ProjectService.unsetProject() on state exit while this view is still being digested
      if (!this.project) {
        return null
      }

      return this.UserService.isClient() ? this.project.contractor : this.project.client
    }

    get title () {
      if (this.customTitle) {
        return this.customTitle
      }

      return `Your ${this.UserService.isClient() ? 'developer' : 'client'}`
    }

    get localTime () {
      const user = this.user
      if (!user) {
        return ''
      }

      const timezone = user.timezoneName || user.timezoneOffset
      return this.$filter('toUserTimezone')(timezone, 'short')
    }

    openReviewModal () {
      this.ModalService.open({
        closeOnBackdrop: false,
        closeIcon: false,
        layout: 'center',
        class: 'project-review-modal',
        template: `<cdbl-project-review-modal project="$ctrl.modal.project"></cdbl-project-review-modal>`,
        project: this.project
      })
    }
  }
}

export default ProjectUserCardComponent
